const Format_Currency = new Intl.NumberFormat(undefined, {
    currency: "USD",
    style: "currency"
})

const FormatCurrency = (number) => {
    return Format_Currency.format(number)
};

export default FormatCurrency;